import { feeProviderCategoryApi, feeProviderCategoryPricingApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { FeatureFlag } from 'constants/featureFlags';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectFeatureFlagByKey } from 'store/global/selectors';

export const FEE_PROVIDER_CATEGORY_TYPE = createNamedActions('feeProviderCategory', {
  GET_CATEGORIES: 'GET_CATEGORIES',
  CREATE_CATEGORY: 'CREATE_CATEGORY',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',
  DELETE_CATEGORY: 'DELETE_CATEGORY',
});

const feeProviderCategoryViewSchema = new schema.Entity(
  'data',
  {},
  { idAttribute: 'feeProviderCategoryId' },
);

const feeProviderCategoryPricingViewSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const getFeeProviderCategoriesAction = catchAsyncActionError(
  () => async (dispatch, getState) => {
    const state = getState();

    const isEnabledPricingFeeProviderCategory = selectFeatureFlagByKey(
      FeatureFlag.UseTransferredFeeProviderCategory,
    )(state);

    const { data } = await (isEnabledPricingFeeProviderCategory
      ? feeProviderCategoryPricingApi.getFeeProviderCategories()
      : feeProviderCategoryApi.getFeeProviderCategories());

    return dispatch({
      type: FEE_PROVIDER_CATEGORY_TYPE.GET_CATEGORIES,
      payload: normalize(data, [
        isEnabledPricingFeeProviderCategory
          ? feeProviderCategoryPricingViewSchema
          : feeProviderCategoryViewSchema,
      ]).entities.data,
    });
  },
);

export const createFeeProviderCategoryAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const state = getState();

    const isEnabledPricingFeeProviderCategory = selectFeatureFlagByKey(
      FeatureFlag.UseTransferredFeeProviderCategory,
    )(state);

    const { data } = await (isEnabledPricingFeeProviderCategory
      ? feeProviderCategoryPricingApi.createFeeProviderCategory(params)
      : feeProviderCategoryApi.createFeeProviderCategory(params));

    return dispatch({
      type: FEE_PROVIDER_CATEGORY_TYPE.CREATE_CATEGORY,
      payload: data,
    });
  },
);

export const updateFeeProviderCategoryAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const state = getState();

    const isEnabledPricingFeeProviderCategory = selectFeatureFlagByKey(
      FeatureFlag.UseTransferredFeeProviderCategory,
    )(state);

    const { data } = await (isEnabledPricingFeeProviderCategory
      ? feeProviderCategoryPricingApi.updateFeeProviderCategory(params)
      : feeProviderCategoryApi.updateFeeProviderCategory(params));

    return dispatch({
      type: FEE_PROVIDER_CATEGORY_TYPE.UPDATE_CATEGORY,
      payload: data,
    });
  },
);

export const deleteFeeProviderCategoryAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const state = getState();

    const isEnabledPricingFeeProviderCategory = selectFeatureFlagByKey(
      FeatureFlag.UseTransferredFeeProviderCategory,
    )(state);

    const { data } = await (isEnabledPricingFeeProviderCategory
      ? feeProviderCategoryPricingApi.deleteFeeProviderCategory(params)
      : feeProviderCategoryApi.deleteFeeProviderCategory(params));

    return dispatch({
      type: FEE_PROVIDER_CATEGORY_TYPE.DELETE_CATEGORY,
      payload: data,
      meta: params,
    });
  },
);
